// Clasifica la incidencia de una sonda a partir de su estado de conexión y último error.
// Mirror del clasificador del backend (_sensor_problem) para que la app en vivo y los
// informes por email digan EXACTAMENTE lo mismo.
//   - SIN CONEXIÓN A INTERNET -> problema de red de datos / internet (solo si el error lo indica)
//   - REVISAR EQUIPO          -> cualquier otro fallo (timeout, sin respuesta, valor inválido,
//                                fuera de rango, pico, error Modbus) = equipo/sonda
export function classifyIncident(sensor) {
  if (!sensor) return null;
  const conn = sensor.connection_status || "online";
  if (conn !== "offline") return null;

  const err = (sensor.connection_error || "").toLowerCase();

  // (1) Problema de red / internet: SOLO cuando el error lo indica claramente
  const redKeys = [
    "sin ruta",
    "no route",
    "network is unreachable",
    "red inalcanzable",
    "unreachable",
    "inalcanzable",
    "rechazada",
    "refused",
    "dns",
    "name resolution",
    "getaddrinfo",
    "red de datos",
    "internet",
  ];
  if (redKeys.some((k) => err.includes(k))) {
    return { code: "SIN CONEXIÓN A INTERNET", cause: "Problema de red de datos / internet" };
  }

  // (2) Resto -> es el equipo/sonda. Un solo mensaje claro.
  return { code: "REVISAR EQUIPO", cause: "Sonda con medidas erróneas" };
}
